import GoogleIcon from "src/assets/logo/google.svg";
import OutlookIcon from "src/assets/logo/outlook.svg";
const AUTH_PROVIDERS = {
  google: {
    icon: GoogleIcon,
    alt: "google",
  },
  outlook: {
    icon: OutlookIcon,
    alt: "outlook",
  },
};
export const AuthIcon = ({ type }: { type: string }) => {
  const provider = AUTH_PROVIDERS[type];

  if (!provider) return null;

  return <img src={provider.icon} alt={provider.alt} width={18} height={18} />;
};
